import { getCustomRound } from "./analysisTable/analysisUtils";

export const AppendStatsToCharts = (data) => {
    const seriesData = data.map((datum) => {
        const _datum = JSON.parse(JSON.stringify(datum));
        delete _datum["title"];
        delete _datum["survey_count"];

        const formattedList = Object.entries(_datum).map(([key, value]) => ({
            name: key
                .split("_")
                .join(" ")
                .replace(/(^|\s)\S/g, function (letter) {
                    return letter.toUpperCase(); // Capitalize the first letter of each word
                }),
            value: value,
        }));

        const obj = {
            value: datum.sample_size,
            name: datum.title,
            details: [...formattedList],
        };

        return obj;
    });

    return seriesData;
};

export const AppendStatsToBarCharts = (data, isPercentage, productColors, tTestResult, productVisibility) => {
    let _rich = [];
    const seriesData = data.map((datum) => {
        const scoreVal = isPercentage ? datum?.percentage : datum?.count;
        const title = `${datum?.title} / ${datum?.study_reference_title}`;
        const checkVisibility = `checked--${datum?.title.split(" ").join("_")}__${datum?.coreDataId}`;
        const color1 = productColors[datum?.title.split(" ").join("_")];
        const filteredTestResult = tTestResult?.[0]?.colors?.find((ele) => ele.productCode.toLowerCase() == datum?.title.toLowerCase()) || {};
        const testColor = filteredTestResult?.common;
        _rich.push({
            backgroundColor: testColor ? testColor : "rgb(255, 255, 255)",
            color: testColor ? "#fff" : "#000",
            padding: [12, 10],
        });

        const obj = {
            value: isPercentage ? datum?.percentage : datum?.count,
            name: datum.title,
            details: [{ name: title, value: scoreVal, itemStyle: { color: color1 } }],
            itemStyle: { color: color1 },
            // details: [...formattedList],
            label: {
                backgroundColor: testColor ? testColor : "rgb(255, 255, 255)",
                color: testColor ? "#fff" : "#000",
                width: isPercentage ? 25 : 20,
                padding: [10, 10, 10, 15],
                borderRadius: 4,
                align: "center",
            },
        };
        if (!productVisibility[checkVisibility]) {
            return obj;
        }
    });

    return {
        seriesData: seriesData,
        _rich: _rich,
    };
};

export const getChartDataFromStatsData = (data, isPercentage, tTestResult, productColors) => {
    let colors = [];
    const seriesData = data.map((datum) => {
        const scoreVal = isPercentage ? getCustomRound(datum?.percentage) : datum?.count;
        const title = `${datum?.title} / ${datum?.study_reference_title}`;
        const filteredTestResult = tTestResult?.[0]?.colors?.find((ele) => ele.productCode.toLowerCase() == datum?.title.toLowerCase()) || {};
        const testColor = filteredTestResult?.common;
        const color = productColors[datum?.title.split(" ").join("_")];
        colors.push(color);
        const obj = {
            value: scoreVal,
            name: title,
            details: [{ name: title, value: scoreVal, itemStyle: { color: "#997326" } }],
            label: {
                backgroundColor: testColor ? testColor : "rgb(255, 255, 255)",
                color: testColor ? "#fff" : "#000",
                width: isPercentage ? 25 : 14,
                padding: [10, 10, 10, 10],
                borderRadius: 4,
                align: "center",
            },
        };

        return obj;
    });

    return {
        seriesData: seriesData,
        _colors: colors,
    };
};
